import React from 'react';
import { ShipMobileResult } from './components/ShipMobileResult';
import { ShipDesktopResult } from './components/ShipDesktopResult';

export const ShipSearchResults = ({ isMobile, liners }) => (
  <>{isMobile ? <ShipMobileResult liners={liners} isMobile={isMobile} /> : <ShipDesktopResult liners={liners} isMobile={isMobile}/>}</>
);
